export default "__VITE_ASSET__Dfwj47Oa__"